import React, { lazy, useEffect, useState } from "react";

// Libraries
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Link, Outlet, useNavigate } from "react-router-dom";

// Components
import {
  Header,
  HeaderCart,
  HeaderLanguage,
  HeaderNav,
  Menu,
  SearchBar,
  Topbar,
} from "../Components/Header/Header";
import FooterStyle01 from "../Components/Footers/FooterStyle01";
import HeaderToolbar from "../Components/Header/HeaderToolbar";
import NewHeader from "../Components/Header/new-header/NewHeader";
import SocialIcons from "../Components/SocialIcon/SocialIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import WhatsAppFloatingButton from "./ecd-pages/WhatsAppFloatingButton ";
import CartIcon from "../Components/Header/CartIcon";
import CartDrawer from "./meldi-dham-pages/product/CartDrawer";
import LoginPage from "./meldi-dham-pages/auth-pages/LoginPage";
import { useDispatch } from "react-redux";
import { clearCart } from "../store/cartSlice";
import { toast } from "react-toastify";
import LogoutConfirmationModal from "./meldi-dham-pages/auth-pages/LogoutConfirmationModal";
const SideButtons = lazy(() => import("../Components/SideButtons"));

const iconData = [
  {
    color: "#828282",
    link: "https://www.facebook.com/",
    icon: "fab fa-facebook-f text-primary",
  },
  {
    color: "#828282",
    link: "https://dribbble.com/",
    icon: "fab fa-dribbble text-[#352525ff]",
  },
  {
    color: "#828282ff",
    link: "https://twitter.com/",
    icon: "fab fa-twitter text-[#3814dbff]",
  },
  {
    color: "#828282",
    link: "https://www.instagram.com/",
    icon: "fab fa-instagram text-[#d60e7cff]",
  },
];
const ElementPage = (props) => {
  const { t, i18n } = useTranslation();
  const [showCart, setShowCart] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [customer, setCustomer] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const session = localStorage.getItem("customer"); // ✅ sessionStorage
    setCustomer(session ? JSON.parse(session) : null);
  }, []);
  // -------------------------------------------------

  const [showModal, setShowModal] = useState(false);
  const handleLogout = () => {
    setShowModal(true);
  };
  const confirmLogout = () => {
    setShowModal(false);
    localStorage.removeItem("customer");
    localStorage.removeItem("checkoutAddress");
    dispatch(clearCart());
    navigate("/page/store", { replace: true });
    console.log("User logged out");
  };

  const cancelLogout = () => {
    setShowModal(false);
  };

  const handleOpenMemberSite = () => {
    window.open("https://member.khunkhaarmeldimaabareja.com/login", "_blank");
  };

  return (
    <>
      {/* Header Start */}
      <Header
        topSpace={{ desktop: true }}
        type="reverse-scroll"
        className="header-with-topbar bg-[#FF4F00] border-b border-[#0000001a] "
      >
        <Topbar className="home-business-topbar border-[#0000001a] md:px-0">
          {/* <Topbar className="home-business-topbar border-[#0000001a] sm:hidden md:px-0"> */}
          <Container>
            {/* <Container fluid> this is use full line toolbar */}
            <Row className="justify-between pl-[15px] lg:pr-[15px] items-center majer-project">
              <HeaderToolbar />
            </Row>
          </Container>
        </Topbar>
        <HeaderNav
          fluid="fluid"
          theme="light"
          // bg="white"
          menu="light"
          containerClass="sm:px-0 pe-0"
          className="px-[25px] py-[0px] md:pr-[15px] md:pl-0 px-0"
          style={{ backgroundColor: "#FF4F00" }}
        >
          <Col className="col-auto col-sm-6 col-lg-2 me-auto ps-lg-0">
            <Link
              aria-label="header logo"
              className="d-flex align-items-center"
              to="/"
            >
              <div className="p-1 m-1">
                {/* Desktop & Laptop logo */}
                <img
                  className="default-logo img-fluid d-none d-md-block"
                  loading="lazy"
                  src="/assets/logo/meldi-dham.png"
                  alt="logo"
                  style={{ maxWidth: "80px" }}
                />

                {/* Tablet logo */}
                <img
                  className="alt-logo img-fluid d-none d-sm-block d-md-none"
                  loading="lazy"
                  src="/assets/logo/meldi-dham.png"
                  alt="logo"
                  style={{ maxWidth: "80px" }}
                />

                {/* Mobile logo */}
                <img
                  className="mobile-logo img-fluid d-block d-sm-none"
                  loading="lazy"
                  src="/assets/logo/meldi-dham.png"
                  alt="logo"
                  style={{ maxWidth: "80px" }}
                />
              </div>
            </Link>
          </Col>
          <Col className="col-auto text-start hidden-xs font-size-0 !pl-[12px]" />
          <Navbar.Toggle className="order-last md:mx-[12px]">
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
          </Navbar.Toggle>
          <Navbar.Collapse className="col-auto justify-end p-0">
            <Menu {...props} />
          </Navbar.Collapse>

          <CartIcon onClick={() => setShowCart(true)} />
          <CartDrawer show={showCart} onHide={() => setShowCart(false)} />
          {!customer ? (
            <button
              className="btn btn-danger bg-red-600 me-1 hover:bg-white hover:text-red-600 transition-colors"
             
              onClick={handleOpenMemberSite}
            >
              Login
            </button>
          ) : (
            <>
              <strong
                className="inline md:hidden text-white me-1 cursor-pointer"
                onClick={handleLogout}
              >
                👤{customer.memberName}
              </strong>
              <strong
                className="hidden md:inline text-dark me-1 cursor-pointer"
                onClick={handleLogout}
              >
                👤{customer.memberName}
              </strong>
            </>
          )}
          <LoginPage show={showLogin} onHide={() => setShowLogin(false)} />
          <LogoutConfirmationModal
            show={showModal}
            onConfirm={confirmLogout}
            onCancel={cancelLogout}
          />
        </HeaderNav>
      </Header>
      <Outlet />


      <footer className="bg-[#FF4F00] text-white pt-5 mt-5 border-top border-dark">
        <div className="container">
          <Row className="align-items-start gy-4">
            <Col md={4} sm={12} className="text-center text-md-start">
              <Link
                aria-label="footer logo"
                className="d-inline-flex align-items-center"
                to="/"
              >
                <img
                  src="/assets/logo/meldi-dham.png"
                  alt="Meldi Dham Logo"
                  loading="lazy"
                  className="img-fluid"
                  style={{ maxWidth: "200px" }}
                />
              </Link>
            </Col>

            <Col md={5} sm={12} className="text-start">
              <p className="text-uppercase fw-bold mb-4 fs-6 text-white">
               {t("menu.contact")}
              </p>
              <p className="mb-2 text-white">
                {t("contect_us")}
              </p>
              <p className="fw-semibold text-white">
                <i className="feather-phone-call me-2 text-white" />
                +91 82008 20261 | +91 84013 61024 <br />
                <small className="text-white">( {t("conectwith")} )</small>
              </p>
            </Col>

           
            <Col md={3} sm={12} className="text-md-end text-center">
              <p className="text-uppercase fw-bold mb-4 fs-6 text-white">
              
                {t("follow")}
              </p>
              <SocialIcons
                size="sm"
                theme="social-icon-style-01"
                className="justify-md-end justify-end text-white"
             
                data={iconData}
              />
            </Col>
            <WhatsAppFloatingButton />
          </Row>
        </div>
        <div className="text-center py-2 border-top border-white">
          <p className="mb-0 text-white">
            © {new Date().getFullYear()} {t("reserved")}.
          </p>
          <a
            href="https://agmetech.com"
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer"
          >
            {" "}
            {t("developed_by")}
          </a>
        </div>
      </footer>
    </>
  );
};

export default ElementPage;
